var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotoSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.886,28.778V21.5H0.75v-4h21.136v-7.278l9.278,9.278L21.886,28.778z M10.169,7.189H8.248L7.351,8.514 L6.498,7.189H4.513L6.394,9.83l-1.957,2.795h1.914l0.997-1.505l0.987,1.505h1.992L8.321,9.771L10.169,7.189z M10.738,12.625h0.656 c-0.02,0.189-0.07,0.342-0.153,0.455c-0.101,0.138-0.278,0.249-0.529,0.331l-0.135,0.045l0.378,0.796l0.106-0.037 c0.311-0.111,0.569-0.265,0.769-0.457c0.206-0.197,0.349-0.424,0.423-0.673c0.071-0.239,0.107-0.567,0.107-0.976v-1.106h-1.622 V12.625z M16.847,7.189l-1.121,3.411l-1.149-3.411h-1.73l2.021,5.331c-0.075,0.254-0.182,0.466-0.316,0.631 c-0.207,0.25-0.624,0.283-1.168,0.173l-0.168-0.033l0.151,1.334l0.088,0.019c0.265,0.057,0.534,0.086,0.803,0.086 c0.268,0,0.515-0.029,0.733-0.087c0.22-0.059,0.408-0.144,0.561-0.251c0.152-0.105,0.29-0.246,0.409-0.42 c0.114-0.168,0.234-0.409,0.357-0.721l2.22-6.062H16.847z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoSelected);
export default __webpack_public_path__ + "static/media/goto-selected.44e0461081c4985780977ca1ded16f81.svg";
export { ForwardRef as ReactComponent };